/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/button-has-type */
import { clsx } from 'clsx'
import { useCallback } from 'react'
// import { Button } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'

import styles from './styles.module.scss'

export const Btn = ({
  children,
  //
  type, // button type, e.g. default - 	button | reset | submit | null
  //
  //
  design,
  className,
  //
  style,
  //
  //
  onClick,
  breakOnClick,
  //
  link,
  externalLink,
  //
  //
  isInProgress,
  disabled,
  //
  isInProgressCircle = true,
  isInProgressText,
  //
  ref,
  //
  //
  //
  replaceComponent,
}) => {
  const navigate = useNavigate()

  //
  //

  const classes = [styles.btn]

  if (Array.isArray(design)) {
    design.forEach((item) => {
      classes.push(styles[`btn_${item}`])
    })
  } else {
    classes.push(styles.btn_default)
  }

  // after design classes to allow overrides
  if (className) {
    classes.push(className)
  }

  // if (variant === 'link' || variant === 'link-underline') {
  //   classes.push(variant)
  // } else if (!design && !styles && !className) {
  //   classes.push('fwidth_medium')
  // }

  //
  //

  const onClickFinal = useCallback(
    (e) => {
      e.preventDefault()

      if (onClick) {
        onClick(e)

        if (breakOnClick) {
          return
        }
      }

      if (link) {
        if (externalLink) {
          globalThis.open(link, '_blank')
          return
        }

        if (
          ['http://', 'https://', 'mailto:', 'tel:'].some((prefix) =>
            link.startsWith(prefix)
          )
        ) {
          globalThis.location.href = link
        } else {
          navigate(link)
        }
      }
    },
    [onClick, link, breakOnClick, externalLink, navigate]
  )

  //
  //

  const isInProgressContent = (
    <>
      {isInProgressCircle && <i className="fas fa-circle-notch fa-spin" />}
      {isInProgressText && <span className="ms-2">{isInProgressText}</span>}
      {!isInProgressText && !isInProgressCircle && <span>...</span>}
    </>
  )

  //
  //

  const props = {
    className: clsx(classes),
    style,
    onClick: onClickFinal,
    href: link,
    disabled: disabled || isInProgress,
    ref,
  }

  const content = isInProgress ? isInProgressContent : children

  //
  //

  if (replaceComponent === 'a') {
    return <a {...props}>{content}</a>
  }

  return (
    <button type={type || 'button'} {...props}>
      {content}
    </button>
  )
}
